module.exports = __webpack_public_path__ + "media/images/front/services/installation-d220f5ca31c5c844294f2902cd4535d1.jpg";